
import { createRouter, createWebHistory, /*createWebHashHistory*/ } from 'vue-router'
import { nextTick } from 'vue'
import { getApp } from '@/utils/public'
const app = getApp();

const homeRoutes = [
    {
        path: '/:path(.*)',
        redirect: '/'
    },
    {
        name: 'Home',
        path: '/',
        component: () => import('../views/home/HomeIndex'),
    },
    {
        name: 'User',
        path: '/user',
        component: () => import('../views/user/UserIndex'),
    },
]
const userRoutes = [
    {
        name: 'Login',
        path: '/login',
        component: () => import('../views/user/login/LoginIndex'),
        meta: { title: '登录' }
    },
    {
        name: 'Register',
        path: '/register',
        component: () => import('../views/user/register/RegisterIndex'),
        meta: { title: '注册' }
    },
    {
        name: 'Retrieve',
        path: '/retrieve',
        component: () => import('../views/user/pad/RetrievePassword'),
        meta: { title: '找回密码' }
    },
    {
        name: 'Password',
        path: '/user/password',
        component: () => import('../views/user/pad/PasswordIndex'),
        meta: { title: '修改密码' }
    },
    {
        name: 'My',
        path: '/user/my',
        component: () => import('../views/user/my/UserEdit'),
        meta: { title: '个人信息' }
    },
    {
        name: 'About',
        path: '/about',
        component: () => import('../views/user/about/AboutIndex'),
        meta: { title: '关于我们' }
    },
    {
        name: 'Logs',
        path: '/logs',
        component: () => import('../views/user/log/LogIndex'),
        meta: { title: '日志记录' }
    },

    {
        name: 'Users',
        path: '/users',
        component: () => import('../views/user/users/UsersIndex'),
        meta: { title: '用户列表' }
    },
    {
        name: 'UserDetail',
        path: '/user/:id',
        component: () => import('../views/user/users/UserDetail'),
        meta: { title: '用户' }
    },
    {
        name: 'UserEdit',
        path: '/user/:id/edit',
        component: () => import('../views/user/users/UserAdd'),
        meta: { title: '编辑用户' }
    },
    {
        name: 'UserAdd',
        path: '/user/:parentId/add',
        component: () => import('../views/user/users/UserAdd'),
        meta: { title: '添加用户' }
    },

    {
        name: 'Type',
        path: '/type/:type',
        component: () => import('../views/user/type/TypeIndex'),
        meta: { title: '列表' }
    },
    {
        name: 'TypeAdd',
        path: '/type/:type/add/:parentId/:index',
        component: () => import('../views/user/type/TypeAdd'),
        meta: { title: '添加' }
    },
    {
        name: 'TypeEdit',
        path: '/type/:type/edit/:id',
        component: () => import('../views/user/type/TypeAdd'),
        meta: { title: '编辑' }
    },
    {
        name: 'TypeDetail',
        path: '/type/:type/detail/:id',
        component: () => import('../views/user/type/TypeDetail'),
        meta: { title: '详情' }
    },

    {
        name: 'PDFAd',
        path: '/user/padad',
        component: () => import('../views/user/pdf/PDFAdIndex'),
        meta: { title: 'PDF推广' }
    },
]
const appRoutes = [
    {
        name: 'Search',
        path: '/home/search',
        component: () => import('../views/home/search/SearchIndex'),
        meta: { title: '全文搜索' }
    },

    {
        name: 'Order',
        path: '/home/order',
        component: () => import('../views/home/order/OrderIndex'),
        meta: { title: '订单列表' }
    },
    {
        name: 'OrderAdd',
        path: '/home/order/add',
        component: () => import('../views/home/order/OrderAdd'),
        meta: { title: '添加订单' }
    },
    {
        name: 'OrderTotal',
        path: '/home/order/total/:type',
        component: () => import('../views/home/order/OrderIndex'),
        meta: { title: '订单统计' }
    },
    {
        name: 'OrderDate',
        path: '/home/order/date/:date',
        component: () => import('../views/home/order/OrderIndex'),
        meta: { title: '订单统计' }
    },
    {
        name: 'OrderCustom',
        path: '/home/order/custom/:customId',
        component: () => import('../views/home/order/OrderIndex'),
        meta: { title: '订单统计' }
    },
    {
        name: 'OrderGood',
        path: '/home/order/good/:type/:goodId',
        component: () => import('../views/home/order/OrderIndex'),
        meta: { title: '订单统计' }
    },
    {
        name: 'OrderDetail',
        path: '/home/order/:id',
        component: () => import('../views/home/order/OrderDetail'),
        meta: { title: '订单' }
    },
    {
        name: 'OrderEdit',
        path: '/home/order/:id/edit',
        component: () => import('../views/home/order/OrderAdd'),
        meta: { title: '编辑订单' }
    },

    {
        name: 'OrderPay',
        path: '/home/order/:id/pay',
        component: () => import('../views/home/order/OrderPayIndex'),
        meta: { title: '付款明细' }
    },
    {
        name: 'OrderPayDetail',
        path: '/home/order/:id/pay/:detailId',
        component: () => import('../views/home/order/OrderPayDetail'),
        meta: { title: '付款明细' }
    },

    {
        name: 'Custom',
        path: '/home/custom',
        component: () => import('../views/home/custom/CustomIndex'),
        meta: { title: '客户列表' }
    },
    {
        name: 'CustomAdd',
        path: '/home/custom/add',
        component: () => import('../views/home/custom/CustomAdd'),
        meta: { title: '添加客户', haveCache: true }
    },
    {
        name: 'CustomDetail',
        path: '/home/custom/:id',
        component: () => import('../views/home/custom/CustomDetail'),
        meta: { title: '客户' }
    },
    {
        name: 'CustomEdit',
        path: '/home/custom/:id/edit',
        component: () => import('../views/home/custom/CustomAdd'),
        meta: { title: '编辑客户' }
    },

    {
        name: 'Good',
        path: '/home/good',
        component: () => import('../views/home/good/GoodIndex'),
        meta: { title: '商品列表' }
    },
    {
        name: 'GoodAdd',
        path: '/home/good/add',
        component: () => import('../views/home/good/GoodAdd'),
        meta: { title: '添加商品', haveCache: true }
    },
    {
        name: 'GoodDetail',
        path: '/home/good/:id',
        component: () => import('../views/home/good/GoodDetail'),
        meta: { title: '商品' }
    },
    {
        name: 'GoodEdit',
        path: '/home/good/:id/edit',
        component: () => import('../views/home/good/GoodAdd'),
        meta: { title: '编辑商品' }
    },

    {
        name: 'Payout',
        path: '/home/payout',
        component: () => import('../views/home/payout/PayoutIndex'),
        meta: { title: '支出项目列表' }
    },
    {
        name: 'PayoutAdd',
        path: '/home/payout/add',
        component: () => import('../views/home/payout/PayoutAdd'),
        meta: { title: '添加支出项目', haveCache: true }
    },
    {
        name: 'PayoutDetail',
        path: '/home/payout/:id',
        component: () => import('../views/home/payout/PayoutDetail'),
        meta: { title: '支出项目' }
    },
    {
        name: 'PayoutEdit',
        path: '/home/payout/:id/edit',
        component: () => import('../views/home/payout/PayoutAdd'),
        meta: { title: '编辑支出项目' }
    },

    {
        name: 'Report',
        path: '/home/report',
        component: () => import('../views/home/report/ReportIndex'),
        meta: { title: '报表统计' }
    },
]

const router = createRouter({
    scrollBehavior: () => ({ y: 0, }),
    history: createWebHistory(process.env.BASE_URL),
    //history: createWebHashHistory(),
    routes: homeRoutes.concat(userRoutes).concat(appRoutes)
})
app.config.router = router
router.beforeEach((to, from, next) => {
    // 记录需要缓存页面的滚动条高度
    if (!from.meta || !from.noKeepAlive) {
        var scrollTop = Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop)
        if (!app.config.meta[from.name]) app.config.meta[from.name] = {}
        app.config.meta[from.name].scrollTop = scrollTop;
        // 刷新标记，从子页返回时不刷新
        // needRefresh=true 需要刷新，从标记页返回强制刷新（如待办待阅）
        // haveCache=true   有缓存，从标记页返回禁止刷新（如地图、文件预览、设置页、个人信息）
        app.config.meta[from.name].iback = to.path.indexOf(from.path) == 0
        if (to.meta.needRefresh) app.config.meta[from.name].iback = false
        if (to.meta.haveCache && !from.path.indexOf(to.path) == 0) app.config.meta[from.name].iback = true//非子页时有效
        if (app.config.meta[to.name]) {
            to.meta.iback = app.config.meta[to.name].iback
            to.meta.scrollTop = app.config.meta[to.name].scrollTop
        }
        if (app.config.iDo > 0) {//提交过数据，重置
            app.config.iDo -= 1
            to.meta.iback = false
        }
    }
    next();
});

router.beforeResolve((to, from, next) => {
    const pageTitle = to.meta && to.meta.title;
    let title = process.env.VUE_APP_TITLE
    if (pageTitle) {
        document.title = `${pageTitle}-${title}`;
    }
    else {
        document.title = title
    }
    next();
    const gotoScroll = to.meta.scrollTop;
    if (to.meta.iback && gotoScroll) {
        nextTick(() => {
            setTimeout(function () {
                //兼容 PC and Mobile 写两个
                document.body.scrollTop = gotoScroll;
                document.documentElement.scrollTop = gotoScroll;
            }, 25);
        })
    }
});


export default router
